import React, { useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FaCheck } from "react-icons/fa";

const Container = styled.ul`
  margin: 0;
`;

const Item = styled.li`
  border: 1px solid;
  border-color: ${({ theme, selected }) =>
    selected ? theme.colors.primary : theme.colors.lightGray};
  border-radius: 3px;
  display: flex;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  margin-bottom: 8px;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
  }

  span {
    margin-right: 10px;
    height: 25px;
    width: 25px;
    border: 1px solid;
    border-color: ${({ theme, selected }) =>
      selected ? theme.colors.primary : theme.colors.lightGray};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${({ theme }) => theme.colors.white};
    transition: background-color 300ms ease;
    background-color: ${({ theme, selected }) =>
      selected && theme.colors.primary};
  }
`;

export default function Select({ items, register, name, defaultValue }) {
  const [selected, setSelected] = useState(defaultValue);

  return (
    <Container>
      {items.map((item) => (
        <Item
          key={item}
          onClick={() => setSelected(item)}
          selected={selected === item}
        >
          <span>
            <FaCheck />
          </span>
          {item}
        </Item>
      ))}
      <input ref={register} name={name} defaultValue={selected} hidden />
    </Container>
  );
}

Select.defaultProps = {
  defaultValue: null,
};

Select.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string.isRequired })
  ).isRequired,
  register: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
};
